<template>
  <b-form @submit.stop.prevent="">
    <b-modal id="add-or-edit-practice-modal" hide-footer hide-header-close hide-header>
      <h1 class="page-title link mb-4" v-if="association === null">{{ $t('Add2') + ' ' + $t('a.e') + ' ' + $t('Audit.practice') }}</h1>
      <h1 class="page-title link mb-4" v-else>{{ $t('Modify') + ' ' + $t('a.e') + ' ' + $t('Audit.practice') }}</h1>
      <AutocompleteField
        ref="autocomplete"
        v-model="this.form.practice.value"
        :input-class="'medium-label mb-4 full-width required-input'"
        :input-id="'practice-input'"
        :tab-index="1"
        :input-label="$t('Audit.choose.practice')"
        :items="this.practices"
        :required=true
        @elementValueChanged="getSelectedValue"
        @newSelectedValue="newSelectedValue"
        @autocompleteMounted="autocompleteMounted">
      </AutocompleteField>
      <b-form-group
        :invalid-feedback="form.technicianNote.value.length > 150 ? $t('150.characters.max.error') : null"
        :label="$t('Audit.technicianNote')"
        :state="form.technicianNote.state"
        class="medium-label mb-4 "
        label-for="technicianNote-input">
        <b-form-textarea
          id="technicianNote-input"
          v-model="form.technicianNote.value"
          :state="form.technicianNote.value.length > 150 ? false : null"
          tabindex="2"
          no-resize>
        </b-form-textarea>
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button variant="primary" @click="nextStep" class="btn-primary ph-btn" :disabled="!hasAPracticeBeenSelected">
          {{ $t('Next.step') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal id="add-or-edit-practice-step-modal" hide-footer hide-header-close hide-header>
      <h1 class="page-title link mb-4" v-if="association === null">{{ $t('Add2') + ' ' + $t('a.e') + ' ' + $t('practice2') }}</h1>
      <h1 class="page-title link mb-4" v-else>{{ $t('Modify') + ' ' + $t('a.e') + ' ' + $t('comment') }}</h1>
      <div v-for="(practiceStep) in getPracticeStepsOfSelectedPractice" :key="practiceStep.id">
        <b-form-group
          :ref="'practiceSteps-label-'+practiceStep.indexPracticeStep"
          :label="$t('Audit.practice.step.comment') + practiceStep.indexPracticeStep + ' - ' + practiceStep.title + '  :' "
          class="medium-label mb-4 "
          :label-for="'practiceSteps-input-'+practiceStep.indexPracticeStep">
          <b-form-textarea
            :id="'practiceSteps-input-'+practiceStep.indexPracticeStep"
            :ref="'practiceSteps-input-'+practiceStep.indexPracticeStep"
            v-model="form.practiceSteps[practiceStep.indexPracticeStep]"
            class="practice-step"
            :tabindex="practiceStep.indexPracticeStep"
            rows="3"
            @input="maxCharForPracticeStepComment(practiceStep.indexPracticeStep)"
            no-resize>
          </b-form-textarea>
        </b-form-group>
      </div>
      <div class="d-flex justify-content-between">
        <b-button variant="primary" @click="prevStep" class="btn-primary ph-btn">
          {{ $t('Prev.step') }}
        </b-button>
        <b-button type="submit" variant="primary" @click="submitPracticeAssociation" class="btn-primary ph-btn">
          {{ $t('Validate') }}
        </b-button>
      </div>
    </b-modal>
  </b-form>
</template>

<script>

import AutocompleteField from '../../components/b122/editFields/AutocompleteField'
import api from '../../services/api'

export default {

  name: 'AddOrEditPracticeModal',

  components: {
    AutocompleteField
  },

  props: {
    auditId: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      askConfirm: false,
      practices: [],
      practicesForPracticesStepForm: {
        number: 0,
        practiceSteps: []
      },
      tempPractice: '',
      practiceSelectedNumber: 0,
      hasAPracticeBeenSelected: false,
      form: {
        practice:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        technicianNote:
          {
            state: null,
            invalidFeedback: null,
            value: ''
          },
        practiceSteps: []
      },
      association: null
    }
  },

  mounted () {
    this.fetchData()
  },

  computed: {
    getPracticeStepsOfSelectedPractice () {
      var filter = Object.values(this.practicesForPracticesStepForm).filter(practice => practice.number === this.practiceSelectedNumber)
      if (filter.length > 0) {
        return filter[0].practiceSteps
      } else {
        return []
      }
    }
  },

  methods: {
    async fetchData () {
      await this.fetchAllPractice()
    },

    async fetchAllPractice () {
      await api
        .get('/practice/')
        .then(response => {
          this.practices = response.data
          this.practicesForPracticesStepForm = response.data
        })
    },

    setInitialValues () {
      this.$bvModal.show('add-or-edit-practice-modal')
      this.hasAPracticeBeenSelected = true
      this.practiceSelectedNumber = this.association.number
      this.form.technicianNote.value = this.association.technicianNote
      var practiceStepsComments = []
      this.association.practiceSteps.forEach((practiceStep) => {
        practiceStepsComments[practiceStep.indexPracticeStep] = practiceStep.comment
      })
      this.form.practiceSteps = practiceStepsComments
    },

    autocompleteMounted () {
      if (this.association !== null) {
        this.$refs.autocomplete.inputValue = this.association.number + ' - ' + this.association.title
      }
    },

    getSelectedValue () {
      this.form.practice.value = this.$refs.autocomplete.inputValue
    },

    newSelectedValue (element) {
      this.practiceSelectedNumber = element.number
      this.hasAPracticeBeenSelected = true
    },

    nextStep () {
      this.$bvModal.hide('add-or-edit-practice-modal')
      this.$bvModal.show('add-or-edit-practice-step-modal')
      this.tempPractice = this.form.practice
    },

    async prevStep () {
      this.$bvModal.hide('add-or-edit-practice-step-modal')
      await this.$bvModal.show('add-or-edit-practice-modal')
      this.$refs.autocomplete.inputValue = this.tempPractice.value
    },

    async submitPracticeAssociation () {
      let data = new FormData()
      data.append('auditId', this.auditId)
      data.append('practice', this.form.practice.value)
      data.append('technicianNote', this.form.technicianNote.value)
      var practiceStepsComments = new Map()
      this.form.practiceSteps.forEach((practiceStepComment, practiceStepIndex) => {
        practiceStepsComments.set(practiceStepIndex, practiceStepComment)
      })
      data.append('practiceSteps', JSON.stringify(Object.fromEntries(practiceStepsComments)))

      var url = '/audit/savePracticeAssociation'
      if (this.association != null) {
        data.append('associationId', this.association.associationId)
        url = '/audit/updatePracticeAssociation'
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(async () => {
          var successMessage = this.$i18n.t('Practice') + ' "' + this.form.practice.value + '" ' + (this.association === null ? this.$i18n.t('f.added') : this.$i18n.t('f.modified'))
          this.tempPractice = ''
          this.practiceSelectedNumber = 0
          this.hasAPracticeBeenSelected = false
          this.form.practice.value = null
          this.form.technicianNote.value = null
          this.form.practiceSteps = []
          this.$bvModal.hide('add-or-edit-practice-step-modal')
          await this.fetchAllPractice()
          this.$emit('refreshPracticeTable')
          this.successToast(successMessage)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(this.$i18n.t(error.response.data.message), {
              title: this.$i18n.t('Error.title'),
              autoHideDelay: 4000,
              toaster: 'b-toaster-bottom-right',
              solid: true
            })
          }
        })
    },

    successToast (message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    },

    maxCharForPracticeStepComment (index) {
      if (this.$refs['practiceSteps-input-' + index][0]._props.value.length > 1000) {
        this.$refs['practiceSteps-input-' + index][0]._props.state = false
        this.$refs['practiceSteps-label-' + index][0]._props.invalidFeedback = this.$i18n.t('1000.characters.max.error')
      } else {
        this.$refs['practiceSteps-input-' + index][0]._props.state = null
        this.$refs['practiceSteps-label-' + index][0]._props.invalidFeedback = null
      }
    }
  }
}
</script>

<style scoped>
.full-width {
  max-width: 100% !important;
  width: 100% !important;
  padding: 0 !important;
}

.practice-step {
  min-height: 0px;
  height: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/audit/AddOrEditPracticeModal.vue